export default __webpack_public_path__ + "static/media/12.4c8ea369.png";